<template>
  <div id="reser_groom">
      <!-- 이사용자가 연장인지 최초 첫구매인지 판단해야함 -->
      <!-- 상품선택 -->
      <div class="pay_process">
          <div class="pay_process_wrap pay_process_wrap_06 hidden-scroll" id="process_wrap" v-if="step==1">
              <div class="progress-bar-wrap">
                  <div class="progress-bar">
                      <div class="bar">
                          <div class="_fill"></div>
                      </div>
                      <div class="point" v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                              <div class="bullet">
                              <img :src="item.img_src">
                          </div>
                          <label class="label">{{item.menu_name}}</label>
                      </div>
                  </div>
              </div>
  
              <div class="process_content">
                  <!-- 달력을 이용한 그룹룸 예약설정  step => 0 -->
                  <div class="room_oneday pay_content">
                      <div class="user_info_wrap">
                          <h1>{{groom_name}}</h1>
                          <ul>
                              <li class="l_txt">
                                  <span class='l_txt_title'>구매상품 : </span>
                                  <span>{{hour_goods_info}}</span>
                              </li>
                          </ul>
                      </div>
  
                      <!-- Calendar -->
                      <div class="calendar_wrap">
                          <div class="cal_head">
                          </div>
                          <div class="cal_body">
                              <FullCalendar ref="fullCalendar" defaultView="dayGridMonth" :plugins="calendarPlugins" :weekends="calendarWeekends" :events="calendarEvents" :header="header" locale='ko' @dateClick="handleDateClick"  />
                          </div>
                      </div>
  
                      <!-- ReserTable -->
                      <div class="room_product_wrap pay_content_wrap">
                          <div class="table-wrapper">
                              <table>
                                  <thead>
                                      <tr>
                                          <th>시작날짜</th>
                                          <th>시작시간</th>
                                          <th>이용시간</th>
                                          <th v-if="groom_type === 'GROOM_PERSON_PLAN'">이용인원</th>
                                          <th>취소</th>
                                      </tr>
                                  </thead>
                              </table>
                              <div class="scroll-area hidden-scroll">
                                  <table class="table02 table-body">
                                      <tbody id="reserv_data">
                                          <template v-if="reserve_info.length !== 0">
                                          <tr  ref="tbody" v-for="(item, index) in reserve_info" :key="index">
                                              <td>{{item.time_info.reserve_date}}</td>
                                              <td>
                                                  <input class="input_usingtime" type="text" :id="'start_time_'+index" :value="item.time_info.time" readonly>
                                              </td>    
                                              <td>
                                                  <input class="input_usingtime" type="text" :id="'use_time_'+index" :value="item.goods_info.time_str" readonly>
                                              </td>                      
                                              <td v-if="groom_type === 'GROOM_PERSON_PLAN'">
                                                  <input class="input_usingtime" type="text" :id="'use_time_'+index" :value="item.goods_info.user_count + '명'" readonly>
                                              </td>                               
  
                                              <td @click="reserve_delete(index)">
                                                  <span class="use_no2">X</span>
                                              </td>
                                          </tr>
                                         
                                          </template>
  
                                          <template v-if="reserve_info.length === 0">
                                          <tr>
                                              <td v-if="groom_type === 'GROOM_PERSON_PLAN'" colspan="5">예약하실 날짜를 선택해주세요.</td>
                                              <td v-else colspan="4">예약하실 날짜를 선택해주세요.</td>
                                          </tr>
                                          </template>
  
                                      </tbody>
                                  </table>
                                   <div v-if="groom_type === 'GROOM_TIME_PLAN'">
                                      <div style="float:left;text-align:left;font-size: 12px;color: #f88009;margin:12px">
                                          <p>※시간충전권 사용시</p> <p>우측 시간충전권 버튼을 선택해주세요.</p>
                                      </div>
                                      <div style="float:right;text-align:right;">
                                          <button type="button" class="hour_none_btn" @click="hour_goods_check('n')" v-if="hour_goods_yn == 'n'">시간충전권 미사용</button>
                                          <button type="button" class="hour_use_btn" @click="hour_goods_check('y')" v-if="hour_goods_yn == 'y'">시간충전권 사용</button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
  
                      <!--시작시간선택팝업-->
                      <div class="type_of_use_wrap" v-if="start_time_sel_check == true">
                          <div class="type_of_use_pop choice_start_pop">
                              <div class="alert-container2">
                                  <div class="alert-head">
                                      <p class="pop_tit mt50">시작 시간 선택</p>
                                  </div>
                                  <div class="alert-body alert-body2">
                                      <div class="tab_contents pop_tab fixedd">
                                          <div class="txt01 mt50 line-point"> <font-awesome-icon :icon="['far', 'calendar-alt']" /> {{pop_str_date}}</div>
                                          
                                          <div class="timer_choice_wrap2">
                                              <template  v-for="(item , index) in reserve_time_list" >
                                                  <h1 class="time_title" v-if="item.time == '00:00'">오전</h1>
                                                  <h1 class="time_title" v-if="item.time == '12:00'">오후</h1>
                                                  <div :class="item.reserve_class" :key="index+'_time_item'" v-bind:style="{background:item.reserve_color}" @click="reserve_time_click(item)" >
                                                      {{item.time}}
                                                  </div> 
                                              </template>
                                              
                                          </div>
                                      </div>
                                  </div>
                                  <div class="type_of_use_footer">
                                      <div  @click="cancel_time_sel_pop" class="btn_close pop_one_btn">취소</div>
                                  </div>
                              </div>
                          </div>
                      </div>
  
                      <!--이용시간선택팝업 : 시간상품-->
                      <div class="type_of_use_wrap" v-if="reserve_goods_sel_check === true && step==1">
                          <div class="type_of_use_pop">
                              <div class="alert-container2">
                                  <div class="alert-head">
                                      <p class="pop_tit">시간 선택</p>
                                  </div>
                                  <div class="alert-body alert-body2 hidden-scroll">
                                      <div class="tab_contents pop_tab fixedd">
                                          <div class="txt01 mt50">
                                              <div class="txt01-title">
                                                  <font-awesome-icon :icon="['far', 'calendar-alt']" />시작일자
                                              </div> 
                                              <div class="txt01-info">{{pop_str_date}}</div>
                                          </div>
                                          <div class="txt01 mt50">
                                              <div class="txt01-title">
                                                  <font-awesome-icon :icon="['far', 'clock']" />시작시간
                                              </div> 
                                              <div class="txt01-info">{{sel_start_time.time}}</div>
                                          </div>
                                          
  
                                          <div class="select_usingtime mt50 botm_content" style="margin:0 !important"  v-if="reserve_goods_sel_check === true && groom_type === 'GROOM_PERSON_PLAN' && step==1">
                                              <div style="width:100%;height:62px;">
                                                  <div class="ml30 botm_txt" style="width:100%;text-align:center;">참여인원 </div>
                                                  <div style="width:100%;margin-top:10px;">
                                                      <div style="float:left;">
                                                          <button style="width:40px !important;height:40px;font-size:20px" @click="user_count_controll(1)">+</button>
                                                          <button style="width:40px !important;height:40px;font-size:20px" @click="user_count_controll(-1)">-</button>
                                                      </div>
                                                      <div style="float:right;font-size:25px;height:40px;line-height:40px;">
                                                          {{this.res_user_count}}명 
                                                      </div>
                                                  </div>
                                                  
                                              </div>                                           
                                          </div>
  
                                          <!-- 251016 그룹룸 이름 추가 -->
                                          <div class="new-group-timer  hidden-scroll">
                                              <template id="timer_ul" v-for="(item, index) in groom_time_list">
                                                  <ul class="timer-goods-item" @click="sel_use_goods(item)" v-if="item.continue_goods_yn != 1">
                                                      <li :class="{'choice' : item.groom_goods_id == sel_goods_info.groom_goods_id}" >
                                                        <div>{{item.groom_goods_name}}</div> {{item.time_str}}</li>
                                                  </ul>
                                              </template>
                                              
                                          </div>
  
                                          <div class="select_usingtime mt50">
                                              <div class="sumary_line">
                                                  <div>이용시간 :</div>
                                                  <div class="nosquare">{{sel_goods_info.time_str}}</div>
                                              </div>
                                              <div class="sumary_line">
                                                  <div>결제금액 :</div>
                                                  <div class="nosquare "><span class="pay-txt">{{sel_goods_info.card_amount}}</span>원</div>
                                              </div>
                                          </div>
  
                                      </div>
                                  </div>
                                  <div class="type_of_use_footer">
                                      <div @click="cancel_goods_sel_pop" class="btn_close" >닫기</div>
                                      <div @click="add_reserve_info" class="btn_ok" >확인</div>
                                  </div>
                              </div>
                          </div>
                      </div>
  
  
                      <div class="total_pay" >
                          <div class="total_pay_wrap">
                              <div>
                                  <span>총 결제금액</span>
                              </div>
                              <div>
                                  <ul>
                                      <li>
                                          <span>카드</span>
                                          <span>{{res_total_card_amount}} 원</span>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
  
                      <div class="pay_content_btn">
                          <div class="prev_btn" @click="reservation_end()">
                              취소
                          </div>
                          <div class="next_btn" @click="set_reserve_next()">
                              다음
                          </div>
                      </div>                    
                  </div> 
              </div>
          </div>
      </div>
  
  
  
      <div class="pay_process">
          <div class="pay_process_wrap hidden-scroll" v-if="step != 1">
              <div class="progress-bar">
                  <div class="bar">
                      <div class="_fill"></div>
                  </div>
                  <div class="point" v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                          <div class="bullet">
                          <img :src="item.img_src">
                      </div>
                      <label class="label">{{item.menu_name}}</label>
                  </div>
              </div>
              <!-- 오른쪽화면 -->
              <div class="process_content">
                  <div class="pay_content_wrap">
  
                      <!-- 마일리지 -->
                      <!-- <div class="pay_content_05" v-if="step==3 && mileage_use_yn == 1"> 원랜 이렇게 사용해야함 매장별 마일리지 사용여부 체크하여 보여줄지 안보여줄지 판단필요 -->
                      <div class="pay_content_05 pay_content" v-if="step==2 && mileage_use_yn == 1">
                          <div class="paytit">
                              <div class="paytit-text"></div>
                          </div>
                          <ul class="hidden-scroll">
                              <template v-if="mileage_chk === false">
                                  <li @click="set_mileage(false)" class="pay-content-on">
                                      <div>마일리지미사용</div>
                                  </li>
                                  <li @click="set_mileage(true)">
                                      <div>마일리지사용</div>
                                  </li>
                              </template>
                              <template v-else>
                                  <li @click="set_mileage(false)">
                                      <div>마일리지미사용</div>
                                  </li>
                                  <li @click="set_mileage(true)" class="pay-content-on">
                                      <div>마일리지사용</div>
                                  </li>
                              </template>
                          </ul>
                          <template v-if="mileage_chk === true">
                              <div class="mg_box_wrap">
                                  <div>
                                      <span>적립금액 :</span>
                                      <mileage @milage="milage_payment" />
                                  </div>
  
                                  <div>
                                      <span>적용금액 :</span>
                                      <span>{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                  </div>
                                  <ul>
                                      <li @click="set_mileage_button(use_min_unit)">+ {{(use_min_unit).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                      <li @click="set_mileage_button(use_min_unit*2)">+ {{(use_min_unit*2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                      <li @click="set_mileage_button(use_min_unit*10)">+ {{(use_min_unit*10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                      <li @click="set_mileage_button('all')">전체적용</li>
                                      <li @click="set_mileage_button('cancel')">전체취소</li>
                                  </ul>
  
                                  <p>※ 최소사용단위 : {{use_min_unit}}원 ※ 최소사용금액 : {{use_min_amount}}원</p>
                              </div>
                          </template>
                      </div>
                      <!-- 할인쿠폰 -->
                      <!-- <div class="pay_content_06" v-if="step==4 && sale_use_yn == 1"> 원랜 이렇게 사용해야함 매장별 마일리지 사용여부 체크하여 보여줄지 안보여줄지 판단필요 -->
                      <div class="pay_content_06 pay_content" v-if="step==3">
                          <div class="paytit">
                              <div class="paytit-text"></div>
                          </div>
                          <ul class="hidden-scroll">
                              <template v-if="discount_coupon === true">
                                  <li @click="set_discount_coupon(false)">
                                      <div>할인쿠폰미사용</div>
                                  </li>
                                  <li @click="set_discount_coupon(true)" class="pay-content-on">
                                      <div>할인쿠폰사용</div>
                                  </li>
                              </template>
                              <template v-else>
                                  <li @click="set_discount_coupon(false)" class="pay-content-on">
                                      <div>할인쿠폰미사용</div>
                                  </li>
                                  <li @click="set_discount_coupon(true)">
                                      <div>할인쿠폰사용</div>
                                  </li>
                              </template>
                          </ul>
                          <template v-if="discount_coupon === true">
                              <div class="cp_box_wrap">
                                  <div class="cp_box">
                                      <span>쿠폰코드 :</span>
                                      <span>{{discount_coupon_code | coupon_filter}}</span>
                                  </div>
                                  <button @click="coupon_check()">적용</button>
                              </div>
  
                              <div class="cp_num_pad">
                                  <div class="pad_btn">
                                      <span @click="coupoun_input('1')">1</span>
                                      <span @click="coupoun_input('2')">2</span>
                                      <span @click="coupoun_input('3')">3</span>
                                      <span @click="coupoun_input('4')">4</span>
                                      <span @click="coupoun_input('5')">5</span>
                                      <span @click="coupoun_input('6')">6</span>
                                  </div>
                                  <div class="pad_btn">
                                      <span @click="coupoun_input('7')">7</span>
                                      <span @click="coupoun_input('8')">8</span>
                                      <span @click="coupoun_input('9')">9</span>
                                      <span @click="coupoun_input('0')">0</span>
                                      <span @click="coupoun_input('del')"><img src='../../assets/image/delete_gy.png'></span>
                                  </div>
  
                              </div>
                          </template>
                      </div>
                      <!-- 결제 전 환불안내 -->
                      <div class="pay_content_06 pay_content" v-if="step==4" style="overflow: hidden">
                        <template v-if="refund !='' && refund != undefined">
                          <p>환불규정</p>
                          <br>
                          <textarea readonly disabled style="width: 100%;height: 100%;border: none;">{{ refund }}</textarea>
                        </template>
                      </div>
  
                      <!-- 결제 완료 -->
                      <div class="pay_content_09 pay_content" v-if="step==5">
                          <div class="finish_payment_wrap">
                              <div class="finish_head" style="border: none;" v-if="res_total_card_amount != 0" >
                                  <ul style="overflow:hidden;">
                                      <li style="width:100%;">
                                          <span class="finish_body" style="display:block;margin:0 auto;font-weight:900;">{{res_total_card_amount}}원</span>
                                      </li>
                                  </ul>
                              </div>
  
                              <div class="finish_body">
                                  <p v-if="res_total_card_amount != 0">결제가 완료되었습니다.</p> 
                                  <img src="../../assets/image/barcode_img.jpg">
                                  <p><br>예약 시간 1시간 전에<br><span>예약번호</span>가 문자발송됩니다.
                                <!-- 250514 이용안내 팝업 추가 -->
                                <div v-if="usage_guide_useyn=='y'" class="guide_btn_wrap">
                                    <div class="guide_btn" @click="open_guide()">이용안내</div>
                                </div>
                                
                                </p>
                              </div>
  
                              <div class="finish_footer pay_content_btn">
                                  <div class="ok_btn" @click="reservation_end()">확인</div>
                              </div>
                          </div>
                      </div>
                      <!-- 결제 완료 -->
  
                      <!-- 미리 구매한 시간충전권으로 사용시 -->
                      <!-- 북마크2 -->
                      <div class="pay_content_07" v-if="step==15">
                          <ul>
                              <template>
                                  <li v-for="(item,index) in reserve_info" :key="index" class="pay-content-on" style="margin-bottom:12%">
                                      {{item.str_use_time}} 예약
                                      <select :id="'myproduct_sel'+index" >
                                          <option id="not_use" :value="item.goods_info.use_hours">--선택--</option>
                                          <option :id="item.groom_purchase_history_id" :value="item.left_hours" v-for="(item,index) in my_time_product_list" :key="index">{{item.left_hours_str}}</option>
                                      </select>
                                  </li>
                              </template>
                          </ul>
  
  
                      </div>
  
                  </div>
                  <div class="pay_info" v-if="step <= 4">
                      <div class="pay_info_wrap" >
                          <div class="pay_wrap">
                              <div class="line_top"></div>
                              <ul>
                                  <li>
                                      <div class="pay_hd">그룹룸번호</div>
                                      <div class="pay_ft">{{groom_name}}</div>
                                  </li>
  
                                  <li>
                                      <div class="pay_hd">상품종류</div>
                                      <div class="pay_ft" v-if="groom_type == 'GROOM_TIME_PLAN'">1일 시간권</div>
                                      <div class="pay_ft" v-if="groom_type == 'GROOM_PERSON_PLAN'">참여 인원권</div>
                                  </li>
  
                                  <li>
                                      <div class="pay_hd">이용시간</div>
                                      <div class="pay_ft">{{res_total_use_hour_datetime}}</div>
                                  </li>
                                  <li>
                                      <div class="pay_hd">마일리지</div>
                                      <div class="pay_ft price">{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}원</div>
                                  </li>
                                  <li>
                                      <div class="pay_hd">할인금액</div>
                                      <div class="pay_ft price">{{discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}원</div>
                                  </li>
                                  <li>
                                      <div class="pay_hd">결제금액</div>
                                      <div class="pay_ft price">{{res_total_card_amount}}원</div>
                                  </li>
                              </ul>
                          </div>
                          <div class="pay_content_btn" v-if="step < 4 && step != 1 ">
                                  <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                                      이전
                                  </div>
                                  <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                                      다음
                                  </div>
                          </div>
                          <div class="pay_content_btn" v-if="step == 4">
                              <div class="prev_btn" @click="step_controll_back()">
                                  이전
                              </div>
                              <div class="next_btn" @click="do_pay_check()">결제하기</div>
                          </div>
                      </div>
                  </div>
                  <div class="pay_info" v-if="step == 15">
                      <div class="pay_info_wrap" >
                          <div class="pay_wrap">
                              <ul>
                                  <li>
                                      <div class="pay_hd">그룹룸</div>
                                      <div class="pay_ft">{{groom_name}}</div>
                                  </li>
                                  <li>
                                      <div class="pay_hd">상품종류</div>
                                      <div class="pay_ft">시간충전권</div>
                                  </li>
                                  <li>
                                      <div class="pay_hd">이용시간</div>
                                      <div class="pay_ft">총 {{res_total_use_hour_datetime}}</div>
                                  </li>
  
                              </ul>
                          </div>
                          <div class="pay_content_btn" v-if="step == 15">
                              <div class="prev_btn" @click="step_controll_back()">
                                  이전
                              </div>
                              <div class="next_btn" @click.once="hour_reserve_click">예약하기</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  
  
  </div>
  </template>
  
  <script>
  // import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  import * as lang from "vuejs-datepicker/src/locale";
  
  // 풀캘린더 추가
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import * as config from '../../javascript/config';
  import external from '@/assets/js/external.js';
  
  export default {
      components: {
          FullCalendar // make the <FullCalendar> tag available
      },
      data: function () {
          return {
              // 풀캘린더 추가
              calendarPlugins: [ // plugins must be defined in the JS
                  dayGridPlugin,
                  timeGridPlugin,
                  interactionPlugin // needed for dateClick
              ],
              header: {
                  left: "",
                  center: "title",
                  right: "prev,next today"
              },
              calendarWeekends: true,
              calendarEvents: [],
  
              left_menu_list: [],
              step: 1,
  
              // 매장정보
              // 그룹룸 정보
              groom_name: '',
              min_user_count:0,
              max_user_count:0,
              groom_goods_info:[],
              groom_goods_list:[],
              groom_type_id : '',
              groom_goods_group_id : '',
              groom_type : '',
              groom_time_list:[],
              groom_limit_use:'N',
              groom_limit_start_time:'',
              groom_limit_end_time:'',
              groom_period_use:'N',
              groom_today_res_info:[],
              groom_next_res_info:[],
              groom_now_use_ifno:[],
  
  
              // 유저 정보
              user_name: '',
              user_hp: '',
              user_id: '',
              hour_goods_info: '',
              hour_goods_time:0,
              my_time_product_value: [],
              my_time_product_list:[],
  
  
              use_count_sel_check: false, // 인원선택 여부
              cash_receipt_check: false, // 현금영수증 체크박스 사용여부
              mileage_chk: false, // 마일리지 사용 여부
  
  
  
              // 선택한 예약 날짜 및 상품 데이터
              reserve_info : [],
              
  
              // 시간선택 팝업 정보
              start_time_sel_check : false,
              pop_str_date:'',
              reserve_time_list:[],
              reserve_ok_class:'res_ok',
              reserve_no_class:'res_no',
              reserve_ok_str:'ok',
              reserve_no_str:'no',
              day_of_week:[],
              sel_start_time:[],
              reserve_goods_sel_check:false,
  
              
  
              // 참여인원 정보
              res_user_count: 0,
  
  
              // 예약 상품 구매 정보
              sel_goods_info:[],
              hour_goods_yn:'n',
              ori_res_total_cash_amount : 0,
              ori_res_total_card_amount : 0,
              res_total_cash_amount : 0,
              res_total_card_amount : 0,
              res_total_use_hours:0,
              res_total_use_hours_datetime:'',
  
  
              // 결제 세팅
              cash: true,
              pay_type: 1, // 0 현금 1 카드 3 default
              card_installment: 0,
              pay_type_str: '카드결제',
              cash_receipt: '0', // 0 == 개인(소득공제) 1 == 법인(지출증빙)
              cash_receipt_flag:false,
              cash_receipt_flag_class_1:'',
              cash_receipt_flag_class_2:'',          
              //마일리지
              mileage_use_yn: '', //해당 매장에서 마일리지 사용여부
              mileage_chk: false,
              mileage_id: null,
              my_save_mileage: 0,
              milage_all: false,
              use_mileage: 0,
              //할인쿠폰
              sale_use_yn: '', //해당 매장에서 할인쿠폰 사용여부
              discount_coupon: false,
              discount_coupon_code: '',
              sale_id: null,
              sale_rate: 0,
              discounted_price_cash: '0',
              discounted_price_card: '0',
              discount_flag: false,
              //영수증 출력 여부
              receipt: 0,
  
              // 결제 정보 관련
              app_number: 0,         // 승인번호
              payment_kind_name: '',  // 현금 : 종류, 카드 : 카드사명
              card_number: '',        // 카드번호(현금영수증번호)
  
              payment_timer : 5,
              timer: '',
              my_mileage: 0,
              card_earn_rate: 0,
              cash_earn_rate: 0,
              groom_use_yn: 0,
              time_type: '',
              refund: '',  // 환불규정

              usage_guide_useyn: 'n', //이용안내 사용여부
              usage_guide_data: null, //이용안내 데이터
          }
      },
      props: [],
      filters: {
          coupon_filter(value) {
              let num = new Number(value);
              num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
              return `${num}`
          }
      },
      methods: {
          get_left_menu() {
              this.left_menu_list = [];
              this.left_menu_list.push({
                  active_class: "process_on",
                  img_src: require("../../assets/image/process03_on.png"),
                  menu_name: "시간선택",
                  nomal_step: 1
              });
              if (this.mileage_use_yn != 0) {
                  this.left_menu_list.push({
                      active_class: "",
                      img_src: require("../../assets/image/process04_on.png"),
                      menu_name: "마일리지",
                      nomal_step: 2
                  });
              }
              if (this.sale_use_yn != 0) {
                  this.left_menu_list.push({
                      active_class: "",
                      img_src: require("../../assets/image/process05_on.png"),
                      menu_name: "할인쿠폰",
                      nomal_step: 3
                  });
              }
              this.left_menu_list.push({
                  active_class: "",
                  img_src: require("../../assets/image/process06_on.png"),
                  menu_name: "결제",
                  nomal_step: 4
              });
              this.left_menu_list.push({
                  active_class: "",
                  img_src: require("../../assets/image/process07_on.png"),
                  menu_name: "완료",
                  nomal_step: 5
              });
  
          },
          groomOptionCheck(){
              // 그룹룸 옵션 정보
              const reserv_type = config.REQ_STORE_OPTION;
              this.$store.dispatch(reserv_type.action_name, {
                  type: reserv_type,
                  data: {'store_id':this.$store.getters['getStoreId']}
              }).then(response => {
                  this.groom_limit_use = response.data.groom_limit_use;
                  this.groom_limit_start_time = response.data.groom_limit_start_time;
                  this.groom_limit_end_time = response.data.groom_limit_end_time; 
                  this.groom_period_use = response.data.groom_period_use;
                  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
  
          },
          get_my_mileage() {
              const get_mileage_settings = config.REQ_GET_MILEAGE_SETTINGS;
  
              this.$store.dispatch(get_mileage_settings.action_name, {
                  type: get_mileage_settings
              }).then(response => {
                  if(response.data.length > 0) {
                      this.card_earn_rate = response.data[0].card_earn_rate
                      this.cash_earn_rate = response.data[0].cash_earn_rate
                      this.groom_use_yn = response.data[0].groom_use_yn
                  }
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
  
              let user_data = this.$store.getters['getUser'];
  
              if (user_data.user_id != 0) {
                  const my_info_data = { 'user_id': user_data.user_id};
                  const type = config.REQ_MILEAGE_GET;
  
                  this.$store.dispatch(type.action_name, {
                      type: type,
                      data: my_info_data
                  }).then(response => {
                      if (response.data.length > 0) {
                          this.my_mileage = response.data[0].total_amount;
                      }
                  }).catch(function (error) {
                      console.log('error=============>', error);
                  });
              }
          },
          logout() {
              clearInterval(this.timer);
              this.$store.commit('user_logout', {
                  value: 'logout'
              });
              this.$router.push('/start');
          },
  
          dateSort(data) {
              data.sort(function (a, b) { // 내림차순
                  return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
              });
          },
  
          handleDateClick(arg) {       
              // 캘린더 선택할때 (오늘로부터 이전날짜 예약 불가능)
              let today = this.$moment(this.$moment().format('YYYY-MM-DD'));
              let click_date = this.$moment(arg.dateStr);   
              if(this.groom_period_use != "N"){
                  // 설정한 기간 외의 날짜에 예약 막기
                  
                  let p_e_date_time = this.$moment(this.$moment().format('YYYY-MM-DD'));         
                  if(this.groom_period_use == "today"){
                  }else if(this.groom_period_use == "tomorrow"){
                      p_e_date_time = p_e_date_time.add(1, 'day');                    
                  }else{
                      let add_month = this.groom_period_use.replace("M", "");
                      p_e_date_time = p_e_date_time.add(add_month, 'month');
                  }
  
                  if(click_date.diff(p_e_date_time) > 0){
                      const alert_param = {
                          code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                          message: `예약이 불가능한 날짜입니다. `,
                          router: '',
                      };
                      this.$store.commit('set_popup_type', alert_param);
                      this.step = 1;
                      return false;
                  }
              }
  
              if (click_date.diff(today) < 0) {
                  const alert_param = {
                      code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                      message: `오늘 날짜로 부터 이전 날짜는 예약이 불가능합니다. `,
                      router: '',
                  };
                  this.$store.commit('set_popup_type', alert_param);
                  this.step = 1;
                  return false;
              }else{
                  this.calendarEvents.push({ 
                      title: '',
                      date: arg.dateStr,
                      allDay: true,
                  })
                  this.dateSort(this.calendarEvents)
  
                  this.showStartTimeZone(arg);
              }
                
          },
  
          // 시작시간 선택 창보여주기
          showStartTimeZone(sel_date_info) {
              let search_date = sel_date_info.dateStr;
              let data = {};
              data.store_id = this.$store.getters['getStoreId'];
              data.groom_id = this.groom_data.groom_id;
              data.search_date = search_date;
              this.pop_str_date = search_date.replace('-', '년 ');
              this.pop_str_date = this.pop_str_date.replace('-', '월 ');
              this.pop_str_date += '일';
              const type = config.RES_GET_GROOM_RESERV_INFO_TIME_LIST;
  
              this.$store.dispatch(type.action_name, {
                  type: type,
                  data: data
              }).then(response => {

                  this.groom_today_res_info = response.search_date_reservations;
                  this.groom_next_res_info = response.next_date_reservations;
                  this.groom_now_use_info = response.current_use_list;
                  // 관리자 강제점유 시간정보
                  this.admin_groom_use_info = response.admin_groom_use_info

                  this.res_time_list(search_date);
  
                  this.start_time_sel_check = true;       // 팝업 오픈
  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
          },
  
          res_time_list(now_date){
              this.reserve_time_list = [];
              let s_date_time = now_date+" 00:00";
              let e_date_time = now_date+" 00:30";
              let s_date_time_no = this.$moment(s_date_time).format('YYYYMMDDHHmm');
              let e_date_time_no = this.$moment(e_date_time).format('YYYYMMDDHHmm');
              let time_list_str = "";
              let s_time_no = "";
              let e_time_no = "";
              let reserve_time_check = "";
              let reserve_class = this.reserve_ok_class;
              let reserve_use_check = this.reserve_ok_str;   // 예약 가능
              
  
              for(let i=0; i<48;i++){
                  if(i == 0){
                      s_date_time = this.$moment(s_date_time).format('YYYY-MM-DD HH:mm');
                      e_date_time = this.$moment(e_date_time).format('YYYY-MM-DD HH:mm');
                      
                  }else{
                      s_date_time = this.$moment(s_date_time).add(30,'minutes').format('YYYY-MM-DD HH:mm');
                      e_date_time = this.$moment(e_date_time).add(30,'minutes').format('YYYY-MM-DD HH:mm');
                  }
  
                  time_list_str = this.$moment(s_date_time).format('HH:mm');
                  s_time_no = this.$moment(s_date_time).format('YYYYMMDDHHmm');
                  e_time_no = this.$moment(e_date_time).format('YYYYMMDDHHmm');
  
                  
  
  
                  
                  // 예약 불가능 시간 ( 관리자, 오늘예약건, 현재사용중 )
                  let reserve_check = this.res_block_time(s_date_time, s_time_no);
                  reserve_class = reserve_check.reserve_class;
                  reserve_use_check = reserve_check.reserve_use_check;
  
  
                  
                  
                  this.reserve_time_list.push({time:time_list_str, s_date_time:s_date_time, e_date_time:e_date_time, s_time_no:s_time_no, e_time_no:e_time_no, reserve_class:reserve_class, reserve_use_check:reserve_use_check});
                  
              }
  
              // 여러개 예약할 경우 본인이 선택한 시간 막기
              if(this.reserve_info.length > 0){
                  for(let s = 0; s < this.reserve_info.length; s++){
                      let sel_reserve_start_time_no = this.reserve_info[s].time_info.s_time_no;            
                      let sel_goods_end_time_no = this.$moment(this.reserve_info[s].time_info.s_date_time).add(this.reserve_info[s].goods_info.use_hours,'minutes').format('YYYYMMDDHHmm');
                      for(let i = 0; i < this.reserve_time_list.length; i++){
                          let s_time_no = this.reserve_time_list[i].s_time_no;
                          if(sel_reserve_start_time_no <= s_time_no && s_time_no < sel_goods_end_time_no){
                              this.reserve_time_list[i].reserve_use_check = "no";
                              this.reserve_time_list[i].reserve_class = "res_sel";
                          }
                      }
                  }
              }            
  
          },
  
          res_block_time(s_date_time, s_time_no){
              
              let reserve_class = "res_ok"; 
              let reserve_use_check = "ok"; 
  
              // 과거시간 예약 막기
              let now_time_no = this.$moment().format('YYYYMMDDHHmm');
              if(s_time_no < now_time_no){
                  reserve_class = "res_no"
                  reserve_use_check = "no"; 
              }
  
  
              // 관리자가 설정한 예약 불가능 시간
              if(this.groom_limit_use == 'Y'){
                  let time_list_h = this.$moment(s_date_time).format("H")
                  let l_start_time = this.groom_limit_start_time;
                  let l_end_time = this.groom_limit_end_time;
                  // 하루를 넘기는지 안넘기는지 체크하기위해
                  if(l_end_time == '0'){
                      l_end_time = 24;
                  }
                  
                  if(Number(l_start_time) < Number(l_end_time)){
                      // 하루가 넘어가지 않는 조건
                      if(Number(l_start_time) <= time_list_h && time_list_h < Number(l_end_time) ){
                          reserve_class = "res_no"
                          reserve_use_check = "no"; 
                      }
                  }else{
                      // 하루가 넘어가는 조건
                      if((Number(l_start_time) <= time_list_h && time_list_h < 24) ||  (0 <= time_list_h && time_list_h < Number(l_end_time))){
                          reserve_class = "res_no"
                          reserve_use_check = "no"; 
                      }
                  }
              }
  
  
              // 기존 예약으로 인한 불가능 시간
              for(let i = 0;i<this.groom_today_res_info.length;i++){
                  let today_res_start_no = this.groom_today_res_info[i].start_datetime_no;
                  let today_res_end_no = this.groom_today_res_info[i].end_datetime_no;
                  if(today_res_start_no <= s_time_no && s_time_no < today_res_end_no){
                      reserve_class = "res_no"
                      reserve_use_check = "no"; 
                  }
  
                  // 시작시간 30분단위때문에 실제 사용시간과 예약시간의 차이가 30분이 나지않으면 사용불가능하게 막아야함
                  let diff_time_no = parseInt(today_res_start_no)-parseInt(s_time_no);
                  if(0 <= diff_time_no && diff_time_no < 30){
                      reserve_class = "res_no"
                      reserve_use_check = "no"; 
                  }
              }
  
              // 사용중으로 인한 불가능 시간
              for(let i = 0;i<this.groom_now_use_info.length;i++){
                  let use_start_no = this.groom_now_use_info[i].start_datetime_no;
                  let use_end_no = this.groom_now_use_info[i].end_datetime_no;
                  if(use_start_no <= s_time_no && s_time_no < use_end_no){
                      reserve_class = "res_no"
                      reserve_use_check = "no"; 
                  }
  
                  // 시작시간 30분단위때문에 실제 사용시간과 예약시간의 차이가 30분이 나지않으면 사용불가능하게 막아야함
                  let diff_time_no = parseInt(use_start_no)-parseInt(s_time_no);
                  if(0 <= diff_time_no && diff_time_no < 30){
                      reserve_class = "res_no"
                      reserve_use_check = "no"; 
                  }
              }
  
              // 관리자 강제점유로 인한 불가능 시간
              for (let i = 0; i < this.admin_groom_use_info.length; i++) {
                let admin_use_start_no = this.admin_groom_use_info[i].start_datetime_no
                let admin_use_end_no = this.admin_groom_use_info[i].end_datetime_no
                if (admin_use_start_no <= s_time_no && s_time_no < admin_use_end_no) {
                  reserve_class = 'res_no'
                  reserve_use_check = 'no'
                }

                // 시작시간 30분단위때문에 실제 사용시간과 예약시간의 차이가 30분이 나지않으면 사용불가능하게 막아야함
                let diff_time_no = parseInt(admin_use_start_no) - parseInt(s_time_no)
                if (diff_time_no >= 0 && diff_time_no < 30) {
                  reserve_class = 'res_no'
                  reserve_use_check = 'no'
                }
              }
  
  
              return {
                  reserve_class : reserve_class,
                  reserve_use_check : reserve_use_check
              }
          },
  
          cancel_time_sel_pop(){
              this.start_time_sel_check = false;
          },
  
          
          reserve_time_click(item) {     
              // 시작시간창에서 시간 선택했을 경우   
              if(item.reserve_use_check == "ok"){
                  item.reserve_date = this.$moment(item.s_date_time).format('YYYY-MM-DD');
                  this.sel_start_time = item;
                  this.show_goods_time();
              }else{
                  this.sel_start_time = [];       // 혹시 모르니까 초기화
                  this.alert_pop("선택한 시간은 예약이 불가능합니다.");                
              }
          },
  
          // 사용시간 선택 창 보여주기
          show_goods_time() {
              this.start_time_sel_check = false;          // 시간 선택창 닫기
              this.reserve_goods_sel_check = true;        // 상품 선택창 열기
          },
  
          cancel_goods_sel_pop(){ 
              this.sel_goods_info = {};                   // 선택 상품 초기화
              this.start_time_sel_check = false;          // 시간 선택창 닫기
              this.reserve_goods_sel_check = false;       // 상품 선택창 닫기
          },
  
          sel_use_goods(item){        
              this.res_user_count = this.min_user_count;
  
              this.sel_goods_info = {};   // 선택 상품 초기화
              this.sel_goods_info.groom_id = this.groom_data.groom_id;        // 그룹룸 정보
              this.sel_goods_info.card_amount = item.card_amount;
              this.sel_goods_info.cash_amount = item.cash_amount;
              this.sel_goods_info.end_day_count = item.end_day_count;
              this.sel_goods_info.groom_goods_group_id = item.groom_goods_group_id;
              this.sel_goods_info.groom_goods_id = item.groom_goods_id;
              this.sel_goods_info.groom_goods_name = item.groom_goods_name;
              this.sel_goods_info.groom_type_id = item.groom_type_id;
              this.sel_goods_info.time_str = item.time_str;
              this.sel_goods_info.use_hours = item.use_hours;
              
              this.sel_goods_info.ori_card_amount = item.card_amount.replace(/,/g,"");
              this.sel_goods_info.ori_cash_amount = item.cash_amount.replace(/,/g,"");
              this.sel_goods_info.user_count = 0;
              if(this.groom_type == "GROOM_PERSON_PLAN"){
                  // 참여인원권일 경우 상품 금액 및 사용자수 세팅 (상품금액 = 상품금액 * 사용자수)
                  this.sel_goods_info.card_amount = this.setCommaFunc(item.card_amount.replace(/,/g,"")*this.min_user_count);
                  this.sel_goods_info.cash_amount = this.setCommaFunc(item.cash_amount.replace(/,/g,"")*this.min_user_count);
                  this.sel_goods_info.user_count = this.min_user_count;
              }
              this.sel_goods_check(this.sel_goods_info);
  
          },
  
          sel_goods_check(item){
              let now_time_no = this.$moment().format('YYYYMMDDHHmm');
              let sel_reserve_start_time_no = this.sel_start_time.s_time_no;            
              let sel_goods_end_time_no = this.$moment(this.sel_start_time.s_date_time).add(item.use_hours,'minutes').format('YYYYMMDDHHmm');
  
              if(sel_reserve_start_time_no < now_time_no){                
                  this.cancel_goods_sel_pop();
                  this.alert_pop("선택한 예약시간이 지났습니다.<br>예약 시간을 다시 선택해주세요.");
              }
  
              // 선택한 상품이 예약 불가능한 시간과 중복되는지 체크
              for(let i = 0; i < this.reserve_time_list.length; i++){
                  let s_time_no = this.reserve_time_list[i].s_time_no;
                  let reserve_use_check = this.reserve_time_list[i].reserve_use_check;
                  if(sel_reserve_start_time_no <= s_time_no && s_time_no < sel_goods_end_time_no){
                      if(reserve_use_check == "no"){                        
                          this.sel_goods_info = {};   // 선택 상품 초기화
                          this.alert_pop("예약이 불가능한 상품입니다.<br>다른 상품을 선택해주세요.");
                      }
                  }
              }
              
            // 관리자 지정 예약 불가 시간 체크(시작 시간 선택 시 통과되는 시간대가 있어서 한 번 더 검증함)
            if(!this.sel_res_block_time(sel_reserve_start_time_no, sel_goods_end_time_no)){
                this.sel_goods_info = {};   // 선택 상품 초기화
                this.alert_pop(`선택하신 시간은 예약 가능한 시간이 아닙니다.<br>다른 시간을 선택해주세요.<br>(예약 불가 시간 : ${this.groom_limit_start_time}시 ~ ${this.groom_limit_end_time}시)`);
            }
          },
        sel_res_block_time(s_start_time, s_end_time){
            // 관리자가 설정한 예약 불가능 시간 체크
            if (this.groom_limit_use !== 'Y') return true;

            const format = "YYYYMMDDHHmm";
            const s_start_tm = this.$moment(s_start_time, format); //선택한 예약 시간시간
            const s_end_tm = this.$moment(s_end_time, format); // 예약 종료 예정시간

            const l_start_t = Number(this.groom_limit_start_time);
            const l_end_t = Number(this.groom_limit_end_time);

            const overlapChk =(baseTm)=> {
                const baseDate = baseTm.format('YYYY-MM-DD');
                let bStart = this.$moment(`${baseDate} ${l_start_t}:00`, "YYYY-MM-DD H:mm");
                let bEnd = this.$moment(`${baseDate} ${l_end_t}:00`, "YYYY-MM-DD H:mm");

                // 자정 처리 (시작이 종료보다 크면 종료를 다음날로)
                if (l_end_t <= l_start_t) {
                    bEnd.add(1, 'days');
                }
                const isOk = s_end_tm.isSameOrBefore(bStart) || s_start_tm.isSameOrAfter(bEnd);
                return isOk;
            }

            //시작일 기준 체크
            const isOkStart = overlapChk(s_start_tm);
            //종료일 기준 체크
            const isOkEnd = s_start_tm.format('YYYYMMDD') === s_end_tm.format('YYYYMMDD') ? true : overlapChk(s_end_tm);
            // console.log('isOkStart: ',isOkStart,' / isOkEnd: ',isOkEnd)
            
            return isOkStart && isOkEnd;
        },
          add_reserve_info(){
              let reserve_info_tmp = {};
              if(Object.keys(this.sel_goods_info).length > 0){
                  reserve_info_tmp.time_info = this.sel_start_time;
                  reserve_info_tmp.goods_info = this.sel_goods_info;
                  this.reserve_info.push(reserve_info_tmp);       // 최종 예약 데이터
                  this.res_total_payment();
  
                  this.sel_start_time = [];                       // 선택한 예약시간 정보 초기화
                  this.sel_goods_info = [];                       // 선택한 상품 정보 초기화
                  this.hour_goods_yn = 'n';                       // 시간충전권 미사용으로 변경
                  this.res_user_count = this.min_user_count;      // 참여인원 초기화
                  this.cancel_goods_sel_pop();
              }else{
                  this.alert_pop("상품을 선택해주세요.");
              }
              
              
          },        
  
          reserve_delete(index){
              let sel_reserve_start_time_no = this.reserve_info[index].time_info.s_time_no;            
              let sel_goods_end_time_no = this.$moment(this.reserve_info[index].time_info.s_date_time).add(this.reserve_info[index].goods_info.use_hours,'minutes').format('YYYYMMDDHHmm');
              // 선택한 상품이 예약 불가능한 시간과 중복되는지 체크
              for(let i = 0; i < this.reserve_time_list.length; i++){
                  let s_time_no = this.reserve_time_list[i].s_time_no;
                  let reserve_use_check = this.reserve_time_list[i].reserve_use_check;
                  if(sel_reserve_start_time_no <= s_time_no && s_time_no < sel_goods_end_time_no){
                      if(reserve_use_check == "no"){
                          this.reserve_time_list[i].reserve_use_check = "ok";
                          this.reserve_time_list[i].reserve_class = "res_ok";
                      }
                  }
              }
  
              this.reserve_info.splice(index, 1);
              this.res_total_payment();
          },
  
          hour_goods_check(val){      
              // 시간충전권 사용 유무
              if(val === 'y'){
                  this.hour_goods_yn = 'n';
              }else{
                  // 여러개 예약할 경우 본인이 선택한 시간 막기
                  if(this.reserve_info.length > 0){
                      let total_use_hour = 0;
                      for(let s = 0; s < this.reserve_info.length; s++){
                          let reserve_use_hour = this.reserve_info[s].goods_info.use_hours;
                          total_use_hour = total_use_hour + parseInt(reserve_use_hour);
                      }
                      if(total_use_hour <= this.hour_goods_time){
                          this.hour_goods_yn = 'y'; 
                      }else{
                          this.hour_goods_yn = 'n';
                          this.alert_pop("보유중인 시간충전권의 남은시간이 부족합니다.<br>예약건을 삭제 또는 변경해주세요.");
                      }
                      
                  }       
                  
              }
          },
  
          user_count_controll(val){
              if(this.sel_goods_info.card_amount == undefined){
                  this.alert_pop(`상품을 선택해주세요.`);
                  return false;       
              }
  
              let sel_user_count = this.res_user_count;
              if(val == 1){
                  sel_user_count = sel_user_count+1;
                  if(this.max_user_count < sel_user_count){
                      this.alert_pop(`해당 그룹룸의 최대 이용자수는 ${this.max_user_count}명 입니다.`);
                      return false;
                  }
              }else{
                  sel_user_count = sel_user_count-1;
                  if(this.min_user_count > sel_user_count){
                      this.alert_pop(`해당 그룹룸의 최소 이용자수는 ${this.min_user_count}명 입니다.`);
                      return false;
                  }
              }
              this.res_user_count = sel_user_count;
              this.sel_goods_info.card_amount = this.setCommaFunc(this.sel_goods_info.ori_card_amount*this.res_user_count);
              this.sel_goods_info.cash_amount = this.setCommaFunc(this.sel_goods_info.ori_cash_amount*this.res_user_count);
              this.sel_goods_info.user_count = this.res_user_count;
          },
          
          res_total_payment(){
              let res_total_cash_amount = 0;
              let res_total_card_amount = 0;
              let res_total_use_hour = 0;
              for(let i = 0; i < this.reserve_info.length; i++){                
                  res_total_cash_amount = res_total_cash_amount+parseInt(this.reserve_info[i].goods_info.cash_amount.replace(/,/g,""));
                  res_total_card_amount = res_total_card_amount+parseInt(this.reserve_info[i].goods_info.card_amount.replace(/,/g,""));
                  res_total_use_hour = res_total_use_hour+parseInt(this.reserve_info[i].goods_info.use_hours);
              }
  
              // 최종 결제 금액
              this.ori_res_total_cash_amount = res_total_cash_amount;     // 마일리지 할인이나 할인쿠폰 적용 전 금액 확인을 위해
              this.ori_res_total_card_amount = res_total_card_amount;     // 마일리지 할인이나 할인쿠폰 적용 전 금액 확인을 위해
              this.res_total_cash_amount = this.setCommaFunc(res_total_cash_amount);
              this.res_total_card_amount = this.setCommaFunc(res_total_card_amount);
              this.res_total_use_hour = res_total_use_hour;
              this.res_total_use_hour_datetime = parseInt(res_total_use_hour / 60) + '시간 ' + parseInt(res_total_use_hour % 60) + '분'; // 상품구매로 예약할때 보여줄시간
              
          },
  
          set_reserve_next(){
              if (this.reserve_info.length > 0) {
                  // 내가가지고있는 시간 충전권으로 예약을 하려는 경우 해당 스탭으로 이동시켜준다
                  if (this.hour_goods_yn === 'y') {
                      this.step = 15;
                  } else {
                      this.step_controll();
                  }
              
              }else{
                  this.alert_pop(`이용시간을 선택해주세요.`);
              }
          },
  
          reservation_end() {
              this.sel_start_time = {};   // 선택한 예약시간 정보 초기화
              this.sel_goods_info = {};   // 선택한 상품 정보 초기화
              this.hour_goods_yn = 'n';   // 시간충전권 미사용으로 변경
              this.$router.push('/');
          },   
  
  
  
          // 여기부터 결제 스텝 함수들
          step_controll() {            
              if(this.step === 1){
                  // 마일리지 초기화
                  this.use_mileage = 0;
                  this.mileage_chk = false;
                  // 할인쿠폰 초기화 (마일리지가 비활성화일때 )
                  this.discount_coupon = false;
                  this.discount_coupon_code = "";
  
                  // 마일리지와 할인쿠폰을 사용하지 않으면 결제방법에서 다음 버튼 클릭시 영수증 스텝으로 이동
                  if (this.mileage_use_yn != 1 && this.sale_use_yn != 1) {
                      this.step = 4;
                  }else{
                      if(this.mileage_use_yn != 1){
                          // 마일리지를 사용하지않으면 할인쿠폰 스텝으로 
                          this.step = 3;
                      }else{                        
                          this.step = 2;
                      }
                  }
              }else if(this.step === 2){
                  // 할인쿠폰 초기화
                  this.set_mileage_use();
                  this.discount_coupon = false;
                  this.discount_coupon_code = "";
                  if(this.sale_use_yn != 1){
                      this.step = 4;
                  }else{
                      this.step = 3;
                  }
  
              }else if(this.step === 3){
                  this.step = 4;
  
              }else if(this.step === 4){
                  this.step = 5;
              }    
          },
  
          step_controll_back() {
              if(this.step === 1){
                   
              }else if(this.step === 2){
                  this.step = 1;
              }else if(this.step === 3){                
                      this.use_mileage = 0;
                      this.mileage_chk = false;
                      this.discount_coupon = false;
                      this.discount_flag = false;
                      this.discount_coupon_code = '';
                      this.discounted_price_cash = 0;
                      this.discounted_price_card = 0;
                      this.res_total_cash_amount = this.setCommaFunc(this.ori_res_total_cash_amount);
                      this.res_total_card_amount = this.setCommaFunc(this.ori_res_total_card_amount);
                      this.step = 2;
              }else if(this.step === 4){                
                      this.use_mileage = 0;
                      this.mileage_chk = false;
                      this.discount_coupon = false;
                      this.discount_flag = false;
                      this.discount_coupon_code = '';
                      this.discounted_price_cash = 0;
                      this.discounted_price_card = 0;
                      this.res_total_cash_amount = this.setCommaFunc(this.ori_res_total_cash_amount);
                      this.res_total_card_amount = this.setCommaFunc(this.ori_res_total_card_amount);
                      this.step = 1;
              }else if(this.step === 15){
                  this.step = 1;
              }
          },
  
          initailiz_payment(){            
              // 결제방법, 마일리지, 할인쿠폰 초기화
              this.pay_type_str = '';
              this.use_mileage = 0;
              this.mileage_chk = false;
              this.pay_type = 1;
  
              this.discount_coupon = false;
              this.discount_coupon_code = "";
              this.discount_flag = false;
              this.discounted_price_cash = 0;
              this.discounted_price_card = 0;
              let price_cash = this.ori_res_total_cash_amount;
              let price_card = this.ori_res_total_card_amount;
              let last_price_cash = price_cash - this.use_mileage;
              let last_price_card = price_card - this.use_mileage;
              this.res_total_cash_amount = this.setCommaFunc(last_price_cash);
              this.res_total_card_amount = this.setCommaFunc(last_price_card);
              
  
          },
  
          set_cash_receipt(val){
              // 현금영수증 선택시 액션
              if(val === 1){
                  this.cash_receipt_flag = false;
                  this.cash_receipt_flag_class_1 = 'select_on';
                  this.cash_receipt_flag_class_2 = '';
                  this.step_controll();
              }else if(val === 2){
                  this.cash_receipt_flag = true;
                  this.cash_receipt_flag_class_1 = '';
                  this.cash_receipt_flag_class_2 = 'select_on';
                  const alert_param = {
                      code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                       message: `현금영수증 선택시 개인은 휴대폰번호<br>법인은 사업자번호를 입력해 주세요.`,
                      router: '',
                      image_type : 'warning'
                  };
                  this.$store.commit('set_popup_type', alert_param);
              }
          },
  
          set_cash_receipt_kind(val){
              // 현금영수증 종류 선택시 액션
              this.cash_receipt = val;
              this.step_controll();
  
          },
  
          // 결제화면 관련
          set_pay_check(index) {
              // 현금결제 정보 초기화
              this.cash_receipt_flag = false;
              this.cash_receipt = '0';
              this.cash_receipt_flag_class_1 = '';
              this.cash_receipt_flag_class_2 = '';
              
              this.pay_type = index;
              this.cash_receipt_flag = false;
              this.cash_receipt = '0';
              if(index == 1){
                  this.pay_type_str = '카드결제';
              }else{
                  this.pay_type_str = '현금결제';
              }       
          },
  
          milage_payment(mileage_data) {
              this.my_save_mileage = mileage_data;
          },
  
          set_mileage(type) {
              if(type){
                  this.mileage_chk = true;
              }else{
                  this.use_mileage = 0;
                  this.mileage_chk = false;
                  this.step_controll();
  
              }
          },
  
          set_mileage_all() {
              this.milage_all = !this.milage_all;
          },
  
          set_mileage_button(value) {
              if(this.use_min_amount > this.my_save_mileage){
                  let use_min_amount_text = this.use_min_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  const alert_param = {
                      code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                      message: `${use_min_amount_text} 마일리지 이상부터 사용 가능합니다.`,
                      router: '',
                      image_type : 'warning'
                  };
                  this.$store.commit('set_popup_type', alert_param);
  
                  this.use_mileage = 0;
                  return false;
              }
              
              if(typeof value === 'number'){
                  this.use_mileage += parseInt(value);
              }else {
                  this.use_mileage =  this.my_save_mileage;
              }
              
              if (this.use_mileage > this.my_save_mileage) {
                  const alert_param = {
                      code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                      message: `사용하시려는 마일리지가 보유하고계신 마일리지보다 큽니다`,
                      router: '',
                      image_type : 'warning'
                  };
                  this.$store.commit('set_popup_type', alert_param);
  
                  this.use_mileage -= value;
                  return;
              }
  
              
              let amount = this.pay_type === 0 ? this.ori_res_total_cash_amount : this.ori_res_total_card_amount;
  
              let remain_pay = parseInt(parseInt(amount)/this.use_min_unit)*this.use_min_unit;
              if(value === 'all'){
                  this.use_mileage = this.my_save_mileage;
                  if(this.use_mileage == 0 || this.use_mileage == '0'){
                      const alert_param = {
                          code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                          message: `보유하고 계신 마일리지가 없습니다.`,
                          router: '',
                          image_type : 'warning'
                      };
                      this.$store.commit('set_popup_type', alert_param);
                  }
  
                  if(remain_pay > this.use_mileage){
                      remain_pay = parseInt(this.use_mileage/this.use_min_unit)*this.use_min_unit;
                      this.use_mileage = remain_pay;
                  }
  
  
                  if(this.use_min_amount > this.use_mileage || remain_pay > this.use_mileage){
                      this.alert_pop("보유하고 계신 마일리지가 충분하지않습니다.");
                      this.use_mileage = 0;
                  }
              }else if(value === 'cancel'){
                  this.use_mileage = 0;
                  return false;
              }
  
              if(amount < this.use_mileage){
                  this.use_mileage = remain_pay;
              }
  
  
          }, 
  
          set_mileage_use(){
              let cash = 0;
              let card = 0;
              cash = this.ori_res_total_cash_amount;
              card = this.ori_res_total_card_amount; 
  
              cash = cash - Number(this.use_mileage) * 1;
              card = card - Number(this.use_mileage) * 1;
  
              this.res_total_cash_amount = cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              this.res_total_card_amount = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
          },
  
          use_mileage_reset() {
              this.use_mileage = 0;
          },
  
          set_discount_coupon(type) {
              if(type){
                  this.discount_coupon = true;
              }else{
                  this.discount_coupon = false;
                  this.step_controll();
              }
          },
  
          set_receipt_chk(index) {
              this.receipt_chk = index;
              this.receipt = index;
              this.step_controll();
          },
  
          // 쿠폰입력
          coupoun_input(type_num) {
              if (type_num == 'del') {
                  if (this.discount_coupon_code.length != 0) {
                      this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length - 1);
                  }
              } else {
                  if (this.discount_coupon_code.length <= 11) {
                      this.discount_coupon_code = this.discount_coupon_code + type_num;
                  } else {
                      return false;
                  }
              }
          },
  
          coupon_check() {
              //할인쿠폰 적용 여부 이곳에서 할인된 가격 적용시켜줘야함
              if (this.discount_coupon) {
  
                  const type = config.REQ_COUPON_GET;
                  const data = {
                      'sale_code': this.discount_coupon_code.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
                  };
                  this.$store.dispatch(type.action_name, {
                      type: type,
                      data: data
                  }).then(response => {
                      let result;
                      result = response.result;
                      if (result && !this.discount_flag && response.data.message) {
                          this.sale_id = response.data.data[0].sale_id;
                          this.sale_rate = response.data.data[0].sale_rate;
  
                          let price_cash = this.res_total_cash_amount.replace(/,/g,"");
                          let price_card = this.res_total_card_amount.replace(/,/g,"");
  
                          //할인된 금액
                          let discounted_price_cash = Math.round(price_cash * (this.sale_rate / 100)); // 정수로 출력하기 위해 소수점 아래 반올림 처리
                          let discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                          // 계산된 최종금액
                          let new_price_cash = price_cash - discounted_price_cash;
                          let new_price_card = price_card - discounted_price_card;
  
  
                          //최종금액
                          let before_res_total_cash_amount = this.res_total_cash_amount
                          this.res_total_cash_amount = this.setCommaFunc(new_price_cash)
                          this.res_total_card_amount = this.setCommaFunc(new_price_card)
                          
  
  
                          // 선택한 각각의 리스트에 할인 적용된 가격을 넣어준다.
                          let regex = /[^0-9]/gi;
  
                          let msg = `할인쿠폰이 적용되었습니다.`;
                          if(this.pay_type == 0){
                              if(discounted_price_cash < 1000){
                                  this.res_total_cash_amount = before_res_total_cash_amount;
                                  discounted_price_cash = 0;
                                  msg = `거스름돈 반환이 불가능하여<br>할인적용이 취소되었습니다.`;
                              }else{
                                  let up_cash = this.res_total_cash_amount.substr(this.res_total_cash_amount.length-3, this.res_total_cash_amount.length);
                                  if(up_cash != '000'){
                                      let cash_Remainder = 1000 - Number(up_cash);
                                      discounted_price_cash = discounted_price_cash - up_cash;
                                      new_price_cash = new_price_cash + cash_Remainder;
                                      this.res_total_cash_amount = this.setCommaFunc(new_price_cash)
                                  }
                                  
                              }
                          }
  
                          this.discounted_price_card = discounted_price_card;
  
                          this.discount_flag = true;
                          this.alert_pop(msg);
                          this.step_controll();  // 스텝이동
  
                      } else if (!result) {
                          this.alert_pop(`쿠폰코드를 다시한번 확인해주세요.`);
                      } else if (result && this.discount_flag) {
                          this.alert_pop(`할인쿠폰이 이미 적용되어있습니다.`);
                      } else {
                          this.alert_pop(`쿠폰코드를 다시한번 확인해주세요.`);
                      }
                  }).catch(function (error) {
                      console.log('error=============>', error);
                  });
              }
          },
  
          do_pay_check(){
              let self = this;
              
              if(this.res_total_card_amount == 0){
                  let result = {
                      "cno" : null,
                      "pay_type" : null
                  };                
                  self.do_pay(result);
              }else{
                  // 결제모듈
                  let pay_info = {
                      mall_id : this.$store.getters['getStoreInfo'].store_imp_code, // 가맹점 ID
                      // mall_id : 'T5102001', // 가맹점 ID
                      mall_nm : this.$store.getters['getStoreInfo'].store_name, // 가맹점명
                      product_nm : 'KIOSK_상품구매(그룹룸_예약)', // 상품이름
                      product_amt : this.res_total_card_amount != 0 ? this.res_total_card_amount.replace(/,/g,"") : this.res_total_card_amount, // 결제금액
                      product_expr : "", // 서비스기간 : YYYYMMDD, 예) 20201231
                      user_id : this.$store.getters['getUser'].user_hp, // 가맹점 고객 ID(가맹점 고객 번호)
                      user_no : this.$store.getters['getUser'].user_id, // 가맹점 고객 일련번호
                      user_nm : this.$store.getters['getUser'].name, // 가맹점 고객명
                      user_phone : this.$store.getters['getUser'].user_hp, // 가맹점 고객 번호
                      sp_user_define1 : this.$store.getters['getStoreInfo'].store_id, // 가맹점 아이디
                      sp_user_define2 : this.$store.getters['getStoreInfo'].store_name // 가맹점 이름
                  }
                  let callbackTemplate = function(command, result){
                      if(String(result.res_cd) == '0000' || result.indexOf("0000") != -1){
                          self.mobileCallBackLog(command, result);        // 결제 로그 추가
                          self.do_pay(result);
                      }else{
                          const alert_param = {
                              code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                              message: result.res_msg,
                              router: '',
                          }
                          this.$store.commit('set_popup_type', alert_param);
                      }
                  };
                  mobileBriddgeConn(pay_info, callbackTemplate);
              } 
  
          },
  
          // 결제 완료 후 결제 내역 생성
          do_pay(result) {
              this.mobileCallBackLog('do_pay', result);        // 결제 로그 추가
              // 공통
              let regex = /[^0-9]/gi;
              let payment_kind_code = '';
              let payment_amount = 0;
              let goods_amount = 0;
              let sale_amount = 0;
              let card_div = 0;
              let get_item_code = this.$store.getters['get_tab_code_list'];
              for (let i = 0; i < get_item_code.length; i++) {
                  if (get_item_code[i].code === "GROOM") {
                      get_item_code = get_item_code[i].code;
                      break;
                  }
              }
  
              //현금 / 카드 사용여부 체크 그에따른 값 셋팅
              if (this.pay_type == 0) {
                  payment_kind_code = 'CASH';
                  payment_amount = this.res_total_cash_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  goods_amount = this.ori_res_total_cash_amount;
                  sale_amount = this.discounted_price_cash;
                  card_div = (this.cash_receipt_flag === false)? 13 : this.card_div;
                  if(card_div == undefined){ card_div = 13 }
              } else {
                  payment_kind_code = 'CARD';
                  payment_amount = this.res_total_card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  goods_amount = this.ori_res_total_card_amount;
                  sale_amount = this.discounted_price_card;
                  card_div = this.card_installment // 1 = 일시불 2 = 2개월
              }
  
              let res_str2 = payment_amount+"_"+goods_amount+"_"+sale_amount+"_"+card_div;
              this.mobileCallBackLog('price_setting', res_str2);        // 결제 로그 추가 
  
              // 마일리지 사용여부 체크
              let mileage = {};
              let mileage_n = 0;
              mileage = {
                  'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '총_금액', => 총금액 - 마일리지 사용 금액
                  'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
              } 
  
              //할인쿠폰 사용여부 체크
              let sale = {}; 
              sale = {
                  'sale_id': this.sale_id,
                  'sale_amount' : sale_amount
              }
  
              if(!this.cash_receipt_flag){ 
                  this.cash_receipt = '0';
              }
              
  
              // 결제 데이터 셋팅
              let payment = new Object;       // 결제정보 + 예약정보         
              payment.payment_kind_code = payment_kind_code; // 현금인지 카드인지
              payment.payment_status_code = 'COMPLETE';
              payment.goods_type_code = get_item_code;
              payment.approval_number = this.app_number;
              payment.cash_receipt = this.cash_receipt;
              payment.card_div = card_div;
              payment.seat_name = this.groom_name;
              payment.payment_amount = payment_amount.replace(/,/g,'');
              payment.goods_amount = goods_amount;
              payment.user_id = this.user_id;
              payment.payment_kind_name = this.payment_kind_name;
              payment.card_number = this.card_number;
              payment.cno = result.cno;
              payment.pay_type = result.pay_type;
              if(this.reserve_info[0].goods_info.groom_goods_name == null || this.reserve_info[0].goods_info.groom_goods_name == 'null'){
                  this.reserve_info[0].goods_info.groom_goods_name = this.reserve_info[0].goods_info.use_hours+'분';
              }
              if(this.reserve_info.length > 1){
                  let other_res_cnt = this.reserve_info.length-1;
                  payment.goods_name = this.groom_name + '_' + this.reserve_info[0].goods_info.groom_goods_name + ' 외 '+other_res_cnt+'건';
              }else{
                  payment.goods_name = this.groom_name + '_' + this.reserve_info[0].goods_info.groom_goods_name;
              }            
              payment.reservation = this.reserve_info;        // 예약 정보
              
              
  
              let data = {};
              data.payment = payment;
              data.mileage = mileage;
              data.sale = sale;
              data.mileage_yn = this.mileage_chk;
              data.sale_yn = this.discount_coupon;
              data.reser_type = 'purchase';
              data.mobile_yn = true;
  
  
              let res_str = JSON.stringify(data);
              this.mobileCallBackLog('data', res_str);        // 결제 로그 추가
  
  
              const type = config.REQ_GROOM_RESERVATION_INSERT;
              this.$store.dispatch(type.action_name, {
                  type: type,
                  data: data
              }).then(response => {
                  if (response == 'complete') {        
                      let res_str3 = JSON.stringify(response); 
                      this.mobileCallBackLog('complete', res_str3);        // 결제 로그 추가             
                      this.step_controll();
                  }
  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
  
          },
          //예약하기
          hour_reserve_click(){
              //북마크2
            let select_MyProduct_Id = []; // 현재 선택된 내 사용권들의 ID 값을 전부 담아놓을 배열
            let MyProduct_Id_for_server = []; //서버로 넘겨줘야할 내 시간상품권 ID 리스트
            let TimeProduct_for_purchase = []; //보유하고있는 내 시간상품권이 모자라서 구매해야할 시간상품권의 시간 리스트
            let will_use_timePlan_total = new Number(); // 예약에 사용할 총시간 (시간기준 / 시간충전권 상품 사용한 예약시간들만)
            let will_use_timePlan = new Number(); // 사용할 예약 시간 ; (시간 기준)
            let MyProduct_leftime = [] // 내가보유하고있는 상품의 시간
            let start_time_list = [] // 예약할 상품의 date time
            let use_time_list = [] // 예약할 상품의 사용할 예약 시간
  
              for (let i = 0; i < this.my_time_product_list.length; i++) {
                  MyProduct_leftime.push(this.my_time_product_list[i].left_hours);
              }
  
              for (let i = 0; i < this.reserve_info.length; i++) {
                  will_use_timePlan = (this.reserve_info[i].goods_info.use_hours);
  
                  let select_leftTimeArray = document.getElementById('myproduct_sel' + i).value; // 남은 시간값을 비교하기위한
                  let select_index = document.getElementById('myproduct_sel' + i).selectedIndex; // 사용자가 선택한  sel 박스의 선택된 자기 상품 option 의 index
                  let select_optionData = document.getElementById('myproduct_sel' + i).options; //그 option에 관련된 데이터 삽입
                  let select_optionID = select_optionData[select_index].id; // 그옵션의 선택되었던 option의 인덱스를 기준으로 id값 집어넣음
                 
  
                  if (select_optionID == 'not_use') {
                      this.alert_pop(`시간충전권을 선택해주세요.`);
                      return false;
                  } else {
                      will_use_timePlan_total += parseInt(this.reserve_info[i].goods_info.use_hours);
                      MyProduct_leftime[select_index - 1] -= will_use_timePlan;
                      if (MyProduct_leftime[select_index - 1] < 0) {
                          this.alert_pop(`해당상품의 시간이 충분하지않습니다 다시확인해주세요.`);
                          return false;
                      }
                  }
  
                  if (Number(select_leftTimeArray) < parseInt(this.reserve_info[i].goods_info.use_hours) && select_optionID != 'not_use') {
                      this.alert_pop(`선택한 시간충전권 상품중 사용할수있는 시간이 충분하지 않은 상품이 있습니다 다시확인해주세요.`);
                      return false;
                  }
                  
                  this.reserve_info[i].groom_purchase_history_id = select_optionID
  
              }
  
              
              // 마일리지 사용여부 체크
              let mileage_n = 0;
              let mileage = {
                  'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '총_금액', => 총금액 - 마일리지 사용 금액
                  'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
              }
  
              //할인쿠폰 사용여부 체크
              let sale = {
                  'sale_id': this.sale_id,
                  'sale_amount' : 0
              }
  
              if(!this.cash_receipt_flag){
                  this.cash_receipt = '0';
              }
  
            // 결제 데이터 셋팅 결제정보 + 예약정보
            const payment = {
                seat_name : this.groom_name,
                user_id : this.user_id,
                reservation: this.reserve_info
            };       
  
            const data = {
                payment,
                sale,
                mileage_yn: '',
                sale_yn: '',
                reser_type : 'timeplan',
                mobile_yn : true
              };

              if (this.reserve_info.length == 0) {
                  this.step = 1
              } else {
                  const type = config.REQ_GROOM_RESERVATION_INSERT;
                  this.$store.dispatch(type.action_name, {
                      type: type,
                      data: data
                  }).then(response => {
                      if (response === 'complete') {
                          this.alert_pop(`시간충전권 예약이 완료되었습니다.<br>예약 시작 1시간 전에 <br>예약번호가 문자발송됩니다`);

                          this.step = 1;
                          this.$router.push('/');
                      }
  
                  }).catch(function (error) {
                      console.log('error=============>', error);
                  });
              }
          },
  
          mobileCallBackLog(command, res){
              const type = config.REQ_GROOM_MOBILE_CALLBACK_LOG_INSERT;
              let data = {};
              data.command = command;
              let res_str = JSON.stringify(res);
              data.res = res_str;
              this.$store.dispatch(type.action_name, {
                  type: type,
                  data: data
              }).then(response => {
                  if (response === 'complete') {
                  }
  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
          },
  
          
          
  
  
  
  
  
  
  
          setCommaFunc(price) {
              return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          },
  
          alert_pop(msg){
              const alert_param = {
                  code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                  message: msg,
                  router: '',
              };
              this.$store.commit('set_popup_type', alert_param);
              return false;
          },
  
          payment_timer_check() {
              this.timer = setInterval(() => {
              this.payment_timer--
  
              if(this.payment_timer === 0){
                  this.logout()
                  clearInterval()
              }
            }, 1000)
          },

        //250514 이용안내 팝업용으로 추가
        async get_usage_guide(){
            const type = config.REQ_GET_USAGE_GUIDE;
            const data = {
                store_id: this.$store.getters['getStoreInfo'].store_id,
            };
            try {
                const response = await this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                });
                if(response.use_yn == 'y'){
                    return response;
                }
                return null;
            } catch (error) {
                console.log('error=============>', error);
                return null;  //실패시 대비
            }
        },
        async open_guide(){
            let send_data = null;
            const result = await this.get_usage_guide();
           // console.log(result)
            if (result) {
                send_data = { 
                            seat_guide: result.seat_guide, 
                            locker_guide: result.locker_guide, 
                            groom_guide: result.groom_guide
                        }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_USE_GUIDE,
                    data: send_data
                }
                this.$store.commit('set_popup_type', alert_param);
            }
        }

      },
      created(){
        this.reserve_info = []; // 예약 날짜 및 상품 데이터 초기화
        this.calendarEvents = []; // 초기화
        this.reserve_time_list = []; // 초기화
      },
      mounted() {
          this.$nextTick(function () {
              this.refund = this.$store.getters['get_refund_text'];              
              this.reserve_info = []; // 예약 날짜 및 상품 데이터 초기화
              this.calendarEvents = []; // 초기화
              this.reserve_time_list = []; // 초기화
          
              
              
              let user_data = this.$store.getters['getUser'];
              this.user_id = this.$store.getters.getUser.user_id;
              this.user_name = this.$store.getters.getUser.name;
              this.user_hp = this.$store.getters.getUser.user_hp;
  
              // 그룹룸 이름
              this.groom_name = this.$store.getters.get_select_groom[0].groom_name;
              this.groom_data = this.$store.getters.get_select_groom[0];
              
              let yndata = this.$store.getters['getUseyn'];
              
              if (typeof yndata == "undefined") {
                  this.sale_use_yn = 0;
                  this.mileage_use_yn = 0;
              } else {
                  this.sale_use_yn = yndata.groom_sale_yn;
                  this.mileage_use_yn = yndata.groom_use_yn;
                  this.use_min_unit = yndata.use_min_unit;
                  this.use_min_amount = yndata.use_min_amount;
              }
  
  
              this.get_left_menu();       // 그룹룸 메뉴 가져오기
              this.groomOptionCheck();        // 그룹룸 옵션 정보 가져옴
              this.get_my_mileage();
  
  
              const my_info_data = {
                  'user_id': user_data.user_id,
                  'groom_type_id': this.groom_data.groom_type_id
              };
  
              // 사용가능한 내 그룹룸 상품목록
              // 해당 매장이 참여인원권이든 1일시간권을 사용하는매장이든 우선 내가가지고 있는 시간충전권의 목록을 불러온다 ( 나중에 1일시간권을 사용하는 매장이라면 불러오도록 수정예정)
              const mygroom_info_type = config.REQ_GET_GROOM_MY_TIMEPRODUCT_INFO_LIST;
              this.$store.dispatch(mygroom_info_type.action_name, {
                  type: mygroom_info_type,
                  data: my_info_data
              }).then(response => {
                  // 내가가지고 있는 시간충전권들의 데이터셋
                  let left_time = 0;
                  for (let i = 0; i < response.data.length; i++) {
                      if (response.data[i].goods_group_name == "시간충전권") {
                          this.my_time_product_list.push(response.data[i]);
                      }
                  }
  
                  for (let i = 0; i < this.my_time_product_list.length; i++) {
                    //   this.my_time_product_list[i].left_hours_str = '남은시간: ' + parseInt(this.my_time_product_list[i].left_hours / 60) + '시간 ' + parseInt(this.my_time_product_list[i].left_hours % 60) + '분';
                    this.my_time_product_list[i].left_hours_str = '[' + this.my_time_product_list[i].groom_goods_name + '] 남은시간: ' + parseInt(this.my_time_product_list[i].left_hours / 60) + '시간 ' + parseInt(this.my_time_product_list[i].left_hours % 60) + '분';
                    left_time += this.my_time_product_list[i].left_hours;
                  }
  
                  this.goods_time = left_time;    
                  this.hour_goods_time = left_time;
                  if (parseInt(this.goods_time) === 0) {
                      this.hour_goods_info = '시간충전권' + '(남은시간: ' + this.goods_time + '시간)';
                  } else {
                      this.hour_goods_info = '시간충전권' + '(남은시간: ' + parseInt(this.goods_time / 60) + '시간 ' + parseInt(this.goods_time % 60) + '분)';
                  }                
  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
  
  
              //해당 매장의 참여인원권이든 1일시간권이든 상관없이 해당 그룹룸의 좌석 및 최소인원 값을 셋팅
              this.min_user_count = this.groom_data.min_user_count;
              this.max_user_count = this.groom_data.groom_seat_count;
              this.res_user_count = this.min_user_count;
  
              const type = config.REQ_GET_GROOM_RESERV_INFO_LIST;
              const data = {};             
              data.groom_id = this.groom_data.groom_id;            
              data.user_id = this.$store.getters.getUser.user_id;
              data.groom_type_id = this.groom_data.groom_type_id;
  
              this.$store.dispatch(type.action_name, {
                  type: type,
                  data: data
              }).then(response => {
                  this.groom_goods_info = response.data;                
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
  
              const req_groom_goods_list = config.REQ_GROOM_GOODS_SEL_GET_LIST;
              this.$store.dispatch(req_groom_goods_list.action_name, {
                  type: req_groom_goods_list,
                  data: data
              }).then(responseList => {
                  this.groom_goods_list = responseList.data;
                  for (let i = 0; i < responseList.data.length; i++) {
                      if (responseList.data[i].selection_plan_code != null) {
                          this.groom_type_id = responseList.data[i].groom_type_id;
                          this.groom_goods_group_id = responseList.data[i].groom_goods_group_id;
                          this.groom_type = responseList.data[i].selection_plan_code;
                      }
                  }
  
                  
                  // 상품들 목록 호출
                  const type = config.REQ_GROOM_TIME_GET_LIST;
                  const data = {
                      'groom_type_id': this.groom_type_id,
                      'groom_goods_group_id': this.groom_goods_group_id
                  };
                  this.$store.dispatch(type.action_name, {
                      type: type,
                      data: data
                  }).then(response => {
                      this.groom_time_list = response.data;
                      for (let i = 0; i < this.groom_time_list.length; i++) {
                          this.groom_time_list[i].time_str = parseInt(this.groom_time_list[i].use_hours / 60) + '시간 ' + parseInt(this.groom_time_list[i].use_hours % 60) + '분';
                      }
  
                  }).catch(function (error) {
                      console.log('error=============>', error);
                  });
                      
  
              }).catch(function (error) {
                  console.log('error=============>', error);
              });

                // 250514 이용안내 추가 
                this.get_usage_guide()
                .then(result => {
                    if (result && result.use_yn === 'y') {
                        this.usage_guide_useyn = 'y';
                        this.usage_guide_data = result;
                    }
                })
                .catch(error => {
                    console.log('error=============>', error);
                });
                
          });
  
      },
      computed: {
          get_popup_code() {
              return this.$store.getters.get_popup_type.code;
          },
          get_time_array_mor() {
              let returnArry = new Array();
              let tempArry;
              for (let i = 0; i < this.time_array_mor.length; i++) {
                  if (i % 2 === 0) {
                      tempArry = new Array();
                      tempArry.push(this.time_array_mor[i]);
                  } else {
                      tempArry.push(this.time_array_mor[i]);
                      returnArry.push(tempArry);
                  }
              }
              return returnArry;
          },
          get_time_array_noon() {
              let returnArry = new Array();
              let tempArry;
              for (let i = 0; i < this.time_array_noon.length; i++) {
                  if (i % 2 === 0) {
                      tempArry = new Array();
                      tempArry.push(this.time_array_noon[i]);
                  } else {
                      tempArry.push(this.time_array_noon[i]);
                      returnArry.push(tempArry);
                  }
              }
              return returnArry;
          }
      },
      beforeDestroy(){
          this.$store.commit('set_payment_Start', false);
      },
      watch: {
          step() {
              
              for (let i = 0; i < this.left_menu_list.length; i++) {
                  this.left_menu_list[i].active_class = '';
                  if (this.left_menu_list[i].nomal_step == this.step) {
                      this.left_menu_list[i].img_src = require("../../assets/image/process0" + (this.left_menu_list[i].nomal_step) + "_on.png");
                      this.left_menu_list[i].active_class = 'process_on';
                      for (let n=0; n<i; n++) {
                          this.left_menu_list[n].active_class = 'process_finish';
                      }
                  } else {
                      
                      this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0" + (this.left_menu_list[i].nomal_step) + ".png");
                  }
              }
          },
          get_popup_code(val, OldVal) {
          },
          choice_use_time() {
          }
      },
  }
  </script>
  
  <style>
  
  .res_ok{float:left; width:20%; height:40px; line-height:40px; font-size:15px; margin:5px; border:1px solid #535150; border-radius:8px; color: #535150; }
  .res_no{float:left; width:20%; height:40px; line-height:40px; font-size:15px; margin:5px; border:1px solid #535150; border-radius:8px; border:1px solid #d8d8d8; background: #e6e6e6; color: #f5f5f5;}
  .res_sel{float:left; width:20%; height:40px; line-height:40px; font-size:15px; margin:5px; border:1px solid #f88009; border-radius:8px; color: #f88009; }
  
  .hour_none_btn{
      margin: 7px;
      width: 120px;
      height: 35px;
      border: 2px solid #c7c7c7;
      border-radius: 5px;
      color: #b3b3b3;
      font-weight: bold;
      background: #ffffff;
      font-size: 13px;
      
  }
  
  .time_title{padding: 15px 0 15px 3%;
    float: left;
    width: 98%;
    text-align: left;}
  .time_title:first-child{padding-top:0;}
  .hour_use_btn{
      margin: 7px;
      width: 120px;
      height: 35px;
      border-radius: 5px;
      color: #fff;
      font-weight: bold;
      background: #f88009;
      font-size: 13px;
  }
  
  .pop_one_btn{border-radius: 0 0 0.8rem 0.8rem;}
  .new-group-timer {
    display:flex;
    padding:0 8px;
    flex-wrap: wrap;
    
   }
    .new-group-timer .timer-goods-item {
        box-sizing:border-box;
        width:calc(33.3% - 4px);
        margin:0 2px 4px; 
        border:1px solid #eee; 
        font-size:0.75em; 
        color:#777; 
        display:flex;
        flex-direction: column;
        align-items:center;
        justify-content:center;
    }
    .new-group-timer .timer-goods-item > li {padding:6px; }
    .new-group-timer .timer-goods-item > li > div {
        font-weight:600;
        color:#000; 
        margin-bottom:4px; 
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-word;
        /* 2줄 이상은 줄임표처리 */
        display: -webkit-box;
        -webkit-line-clamp: 2; 
        -webkit-box-orient: vertical; 
        width:100%;
    }
  </style>


// WEBPACK FOOTER //
// src/components/page/Payment_group_room_reservation.vue